import { atom } from "recoil";

export const WideState = atom<boolean>({
  key: "wide",
  default: true,
});
